import { c as _c } from "react/compiler-runtime";
const SectionStatBlocks = statBlockData => {
  const $ = _c(4);
  let t0;
  if ($[0] !== statBlockData.data?.statBlocksCollection?.items) {
    t0 = statBlockData?.data?.statBlocksCollection?.items?.length > 0 && <div className="flex flex-col items-center justify-between gap-2 md:flex-row">{statBlockData?.data?.statBlocksCollection?.items?.map(_temp)}</div>;
    $[0] = statBlockData.data?.statBlocksCollection?.items;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="row">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default SectionStatBlocks;
function _temp(statBlock, index) {
  return <div key={index} className="bg-white shadow-md align-center my-4 flex w-full max-w-xs flex-col justify-center rounded-lg px-6 py-12 text-center md:px-12 lg:py-24"><span className="mb-4 inline-block text-4xl font-bold uppercase">{statBlock?.headline}</span><p className="text-base">{statBlock?.description}</p></div>;
}